import React from 'react';

const AsLabel = ({ name, value, style, ...props }) => {
    style = {
        display: 'block',
        textAlign: 'left',
        fontSize: 12,
        color: '#414141',
        ...style
    };

    return <label {...props} style={style} htmlFor={name} />;
};

export default AsLabel;
